import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Typography from '@mui/material/Typography';
import { Translate } from '../../../../../shared/LanguageService';
import { FirmProduct } from '../types';
import { ProductCard } from './ProductCard';

type SelectProductsStepProps = {
    products: FirmProduct[];
    productTypeNames: string[];
    shownProductTypeName: string | null;
    chosenProductId: number | null;
    onShowProductType: (productTypeName: string) => void;
    onChooseProduct: (productId: number) => void;
};

export function SelectProductsStep({
    products,
    productTypeNames,
    shownProductTypeName,
    chosenProductId,
    onShowProductType,
    onChooseProduct
}: SelectProductsStepProps) {
    if (products.length === 0) {
        return <Typography>{Translate('order/create/v2/step/products/none')}</Typography>;
    }

    return (
        <>
            <Tabs
                value={shownProductTypeName}
                onChange={(event, productTypeName: string) => onShowProductType(productTypeName)}
                variant="scrollable"
                scrollButtons="auto"
                sx={{ marginBottom: '16px' }}
            >
                {productTypeNames.map((productTypeName) => (
                    <Tab
                        key={productTypeName}
                        value={productTypeName}
                        label={productTypeName}
                        sx={{ fontSize: '14px', textTransform: 'none' }}
                    />
                ))}
            </Tabs>
            <Box sx={{ display: 'grid', gap: '16px' }}>
                {products
                    .filter((product) => product.productTypeName === shownProductTypeName)
                    .map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            chosen={product.id === chosenProductId}
                            choice="one"
                            locked={false}
                            onChoose={() => onChooseProduct(product.id)}
                        />
                    ))}
            </Box>
        </>
    );
}
